<div class="px-[2rem] py-[1rem]">
  <h1>{{ 'APP.XS2A_REDIRECT.TITLE' | translate }}</h1>
</div>
